import { UAParser } from 'ua-parser-js';

export const isMobile = () => window.innerWidth < 768;
export const isTablet = () => window.innerWidth >= 768 && window.innerWidth < 1199;
export const isDesktop = () => window.innerWidth >= 1200;

export const deviceTypeByWidth = () => {
	if (isMobile()) return 'mobile';
	if (isTablet()) return 'tablet';
	if (isDesktop()) return 'desktop';
};

//Get the distance from an element to the top of the document
export const getOffsetTop = function (elem) {
	// Set our distance placeholder
	var distance = 0;

	// Loop up the DOM
	if (elem.offsetParent) {
		do {
			distance += elem.offsetTop;
			elem = elem.offsetParent;
		} while (elem);
	}

	// Return our distance
	return distance < 0 ? 0 : distance;
};

export const getURLParameter = sParam => {
	const sPageURL = window.location.search.substring(1);
	const sURLVariables = sPageURL.split('&');

	for (let i = 0; i < sURLVariables.length; i++) {
		const sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] == sParam) {
			return sParameterName[1];
		}
	}
};

export const isWoocommerceUrl = (url = '') => {
	const urlHasSubstring = substring => url.indexOf(substring) > -1;
	const substrings = ['/checkout', '/cart', '/product/', 'gifts/account'];
	return substrings.some(urlHasSubstring);
};

export const isAdminUrl = (url = '') => {
	const urlHasSubstring = substring => url.indexOf(substring) > -1;
	const substrings = ['/wp-admin'];
	return substrings.some(urlHasSubstring);
};

//Set, get & delete cookies
export const setCookie = (name, value, days) => {
	var expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
};
export const getCookie = name => {
	var nameEQ = name + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
};
export const eraseCookie = name => {
	document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const postRequest = async function (data) {
	const response = await fetch(igniteJsVars.ajaxurl, {
		method: 'POST',
		body: data,
	});

	if (!response.ok) {
		throw new Error(`[${response.status}] ${response.statusText}`);
	}

	const responseJson = await response.json();

	return responseJson;
};

export const decodedString = encodedString => {
	const textarea = document.createElement('textarea');
	textarea.innerHTML = encodedString;
	return textarea.value;
};

export const usingMobileDevice = () => {
	const { device } = UAParser(navigator.userAgent);
	let isMobile = false;

	switch (device.type) {
		case 'console':
		case 'embedded':
		case 'mobile':
		case 'smarttv':
		case 'tablet':
		case 'wearable':
		case 'xr':
			isMobile = true;
			break;
		default:
			isMobile = false;
	}

	return isMobile;
};

export const supportsPopover = () => {
	return typeof Object.hasOwn === 'function' ? Object.hasOwn(HTMLElement.prototype, 'popover') : false;
};

export const getFocusableElements = container => {
	if (!container) return [];

	const focusableElements = container.querySelectorAll(
		'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
	);

	return Array.from(focusableElements);
};

export const trapFocus = (e, firstFocusable, lastFocusable) => {
	if (e.key !== 'Tab') return;

	if (e.shiftKey && document.activeElement === firstFocusable) {
		e.preventDefault();
		lastFocusable.focus();
	} else if (!e.shiftKey && document.activeElement === lastFocusable) {
		e.preventDefault();
		firstFocusable.focus();
	}
};
